<template>
  <WithPaginationAndFilters
    :is-raised="false"
    :is-loading="isLoading"
    :data="campaigns"
  >
    <template slot-scope="{ data, sortChange, filterChange }">
      <ElTable
        :data="data"
        show-overflow-tooltip
        stripe
        :row-style="{ cursor: 'pointer' }"
        row-key="id"
        @sort-change="sortChange"
        @filter-change="filterChange"
        @row-click="goToCampaign"
      >
        <ElTableColumn
          width="200"
          prop="name"
          :label="$t('ADVERTISEMENT.CAMPAIGNS.NAME')"
          fixed
        />
        <ElTableColumn
          width="150"
          prop="packageName"
          :label="$t('ADVERTISEMENT.CAMPAIGNS.PACKAGE_NAME')"
        />
        <ElTableColumn
          width="130"
          :label="$t('ADVERTISEMENT.CAMPAIGNS.BUDGET')"
          prop="remainingBudget"
          sortable
        >
          <template v-slot="{ row }">
            {{ priceFormat(row.remainingBudget) }}
          </template>
        </ElTableColumn>
        <ElTableColumn
          width="130"
          :label="$t('ADVERTISEMENT.CAMPAIGNS.SPENT_BUDGET')"
          prop="spentBudget"
          sortable
        >
          <template slot-scope="{ row: { spentBudget } }">
            {{ priceFormat(spentBudget) }}
          </template>
        </ElTableColumn>
        <ElTableColumn
          width="100"
          :label="$t('ADVERTISEMENT.CAMPAIGNS.START_DATE')"
          prop="startDate"
        >
          <template slot-scope="{ row: { startDate } }">
            {{ translateDate(startDate) }}
          </template>
        </ElTableColumn>
        <ElTableColumn
          width="100"
          :label="$t('ADVERTISEMENT.CAMPAIGNS.END_DATE')"
          prop="endDate"
        >
          <template slot-scope="{ row: { endDate } }">
            {{ translateDate(endDate) }}
          </template>
        </ElTableColumn>
        <ColumnWithHelp
          :width="100"
          :title="$t('ADVERTISEMENT.CAMPAIGNS.STATUS')"
          :content="$t('ADVERTISEMENT.CAMPAIGNS.STATUS_DISCOVERY_DESCRIPTION')"
          :label="$t('ADVERTISEMENT.CAMPAIGNS.STATUS')"
        >
          <template slot-scope="{ row: { status } }">
            {{ $t(translateCampaignStatus(status)) }}
          </template>
        </ColumnWithHelp>
        <ElTableColumn
          width="200"
          sortable
          :label="$t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.TARGETED_CPI')"
          prop="targetedCpi"
        >
          <template slot-scope="{ row: { targetedCpi } }">
            {{ priceFormat(targetedCpi) }}
          </template>
        </ElTableColumn>
        <ElTableColumn
          width="130"
          sortable
          :label="$t('ADVERTISEMENT.CAMPAIGNS.DAILY_CAP')"
          prop="dailyCap"
        >
          <template slot-scope="{ row: { dailyCap } }">
            {{ priceFormat(dailyCap) }}
          </template>
        </ElTableColumn>
      </ElTable>
    </template>
  </WithPaginationAndFilters>
</template>

<script>
import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';
import WithPaginationAndFilters from '@@/common/paginations/WithPaginationAndFilters';

import { format as priceFormat } from '@/utils/number';
import { dateFormat } from '@/utils/date';
import lang from '@/mixins/lang';

import translateCampaignStatus from '../../common/utility/translators/translateCampaignStatus';

export default {
  name: 'CampaignsList',
  components: {
    WithPaginationAndFilters,
    ColumnWithHelp,
  },
  mixins: [lang],
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    campaigns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    translateCampaignStatus,
    priceFormat,
    translateDate(date) {
      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      return dateFormat()(toFormat)(date);
    },
    goToCampaign({ id: campaignId }) {
      this.$router.push({
        name: 'discovery-ads-campaign-info',
        params: { campaignId },
      });
    },
  },
};
</script>
